import React from "react";
import { Navigate } from "react-router-dom";

// Accept requiredUserType prop for user type protection
const PrivateRoute = ({ element: Component, requiredUserType, ...rest }) => {
  const userData = localStorage.getItem("user");
  if (!userData) {
    return <Navigate to="/signin" />;
  }

  let userType;
  try {
    const parsed = JSON.parse(userData);
    // Try both possible locations for user type
    userType = parsed?.data?.userType || parsed?.data?.user?.user_type;
  } catch {
    return <Navigate to="/signin" />;
  }

  if (requiredUserType && userType !== requiredUserType) {
    return <Navigate to="/" />;
  }

  return <Component {...rest} />;
};

export default PrivateRoute;
